<template>
  <div :id="!!id.length ? id : null" class="what-we-do">
    <div data-entrance="fade" class="what-we-do__background-wrapper">
      <YellowBlob class="what-we-do__background-shape" />
    </div>
    <div class="push-v--desktop--small row justify-content-lg-center">
      <div class="col-10 offset-1 col-lg-11 offset-lg-0">
        <h2 v-if="title" data-entrance="fade" class="what-we-do__title h4 text-center">{{ title }}</h2>
        <div class="row justify-content-md-between justify-content-lg-between">
          <div
              v-for="(item, index) in items"
              :key="index"
              data-entrance="fade"
              class="what-we-do__card col-12 col-md-5 offset-md-0 col-lg-3 offset-lg-0"
          >
            <h3 class="what-we-do__card-title h5">
              {{ item.title }}
            </h3>
            <div
                class="push-v--mobile--medium push-v--tablet--medium  what-we-do__card-body text--faux"
                v-html="item.body"
            />
          </div>
        </div>
      </div>
    </div>
    <KenticoResponsiveImage :src="image.url" :alt="image.description" class="what-we-do__image" data-entrance="from-right" :sizes="imageSizes" />
  </div>
</template>

<script>
import getStatic from '~/utils/get-static';
import YellowBlob from '~/assets/images/what-we-do/yellow-shape.svg?inline';
import { BREAKPOINTS, BREAKPOINT_MD, BREAKPOINT_LG } from '~/utils/constants';

export default {
  components: {
    YellowBlob,
  },
  props: {
    id: { type: String, default: '' },
    title: { type: String, default: 'What we do' },
    image: {
      type: Object,
      default() {
        return {
          url: getStatic('/images/content/what-we-do/people-cycling.png'),
          description: '',
        };
      },
    },
    items: {
      type: Array,
      required: true,
      default() {
        return [
          {
            title: 'Co-living',
            body:
              '<p>A new take on an old theme, co-living invites you to be part of something bigger by living in a more connected way with the people around you. Live as part of a community, sharing beautiful spaces and daily events, with your own private apartment.</p>',
          },
          {
            title: 'Event Spaces',
            body:
              '<p>Nothing brings people together like an event. And you cant hold an event without the perfect space. That\'s why The Collective has created inspiring venues designed for the sharing of ideas and experiences.</p>',
          },
          {
            title: 'Serviced Living',
            body:
              '<p>Quality, modern and serviced apartments, studios and rooms in some of Londons most iconic locations, our serviced living buildings combine the best of both worlds. With beautifully furnished private rooms, as well as access to communal spaces, our houses provide a unique sense of community and luxury in some of Londons hotspots.</p>',
          },
          {
            title: 'Co-working',
            body:
              '<p>It\'s all about the environment when youre working on your next big thing. With inspiring workspaces designed for collaboration and innovation, The Collectives work-spaces provide the type of environments where people, ideas and ambitions come together to make something amazing.</p>',
          },
        ];
      },
    },
  },
  data() {
    return {
      imageSizes: {
        default: [493, 367],
        sizes: [
          { breakpoint: BREAKPOINTS[BREAKPOINT_MD], width: 493, height: 369 },
          { breakpoint: BREAKPOINTS[BREAKPOINT_LG], width: 530, height: 396 },
        ],
      },
    };
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_what-we-do.scss';
</style>
